import { render, staticRenderFns } from "./appoint_review.vue?vue&type=template&id=8fdb6266&scoped=true&"
import script from "./appoint_review.vue?vue&type=script&lang=js&"
export * from "./appoint_review.vue?vue&type=script&lang=js&"
import style0 from "./appoint_review.vue?vue&type=style&index=0&id=8fdb6266&lang=less&scoped=true&"
import style1 from "./appoint_review.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fdb6266",
  null
  
)

export default component.exports